import { css } from 'styled-components'

import { helpers } from './theme'

export const scaffolding = css`
	*,
	*:after,
	*:before {
		box-sizing: border-box;
	}

	* {
		&::-moz-focus-inner {
			border: 0;
		}

		&:focus {
			outline: none;
		}
	}

	html {
		font-family: ${helpers.font.family.base};
		font-size: ${helpers.font.size.base};
		line-height: 1.428571429;
		color: ${helpers.color.text};
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);

		overflow-wrap: anywhere;
	}

	body {
		background-color: ${helpers.color.background};
		-webkit-font-smoothing: auto;
	}

	button,
	input,
	select,
	textarea {
		font-family: inherit;
		font-size: inherit;
		line-height: inherit;
	}

	a {
		color: ${helpers.color.link};

		&:focus,
		&:hover {
			color: ${helpers.color.link};
		}

		&:focus {
			outline: 5px auto -webkit-focus-ring-color;
			outline-offset: -2px;
		}
	}

	img {
		vertical-align: middle;
	}

	hr {
		margin: ${helpers.font.size.base} 0;
		border: 0;
		border-top: 2px solid ${helpers.color.separator};
	}

	*::-webkit-scrollbar {
		background-color: transparent;
		width: 8px;
	}

	*::-webkit-scrollbar-thumb {
		background-color: ${helpers.color.scrollbarThumb};
		border-radius: 8px;
		border: none;
	}
`
